import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-chartjs',
	templateUrl:'./ChartJsPluginPage.html',
	styles: [],
	styleUrls:['./ChartJsPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class ChartJsPluginPage
{
	mdContent_75 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>chartjs</artifactId>
</dependency>
\`\`\``;
	mdContent_76 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:chartjs:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_77 = `\`\`\`java
BarDataset dataset = new BarDataset()
    .setLabel("Monthly Sales")
    .setData(65, 59, 80, 81, 56, 55, 40)
    .addBackgroundColors(Color.RED, Color.GREEN,
        Color.BLUE, Color.YELLOW)
    .setBorderWidth(2);

BarData data = new BarData()
    .addLabels("Mon", "Tue", "Wed", "Thu",
        "Fri", "Sat", "Sun")
    .addDataset(dataset);

String json = new BarChart(data).toJson();
\`\`\``;
	mdContent_78 = `\`\`\`java
BarDataset dataset = new BarDataset()
    .setLabel("Monthly Sales")
    .setData(65, 59, 80, 81, 56, 55, 40)
    .addBackgroundColors(Color.RED, Color.GREEN,
        Color.BLUE, Color.YELLOW)
    .setBorderWidth(2);

BarData data = new BarData()
    .addLabels("Mon", "Tue", "Wed", "Thu",
        "Fri", "Sat", "Sun")
    .addDataset(dataset);

String json = new BarChart(data).toJson();
\`\`\``;
}
